import { getId, isProcessing } from 'find-and-filter-data/views-schema/public';
import { NavViewLink } from 'svh-workspace-ui-lib/navigation-sidebar/public';
import { GYPSUM, KOALA } from 'HubStyleTokens/colors';
import styled from 'styled-components';
import { jsx as _jsx } from "react/jsx-runtime";
const viewWrapper = () => styled.div.withConfig({
  displayName: "InboxNavViewLink__viewWrapper",
  componentId: "sc-1cev7lp-0"
})(["&&{max-width:222px;width:100%;cursor:pointer;background-color:", ";:hover{background-color:", ";}}"], ({
  selected
}) => selected ? `${KOALA} !important` : 'transparent', GYPSUM);
export const InboxNavViewLink = ({
  handleDeleteViewClick,
  handleEditViewClick,
  handleViewMemberClick,
  view,
  viewId,
  hasCustomViewsAccess
}) => {
  const id = getId(view);
  return /*#__PURE__*/_jsx(NavViewLink, {
    view: view,
    handleViewMemberClick: handleViewMemberClick,
    viewId: viewId,
    wrapperEl: viewWrapper,
    actions: [{
      disabled: isProcessing(view),
      onClick: event => handleEditViewClick(event, id),
      testId: 'edit-view-button',
      disabledText: 'svh-workspace-ui-lib.custom-views.editWizard.disableTooltip.processing',
      buttonText: 'svh-workspace-ui-lib.custom-views.editCustomViewButton'
    }, {
      disabled: !hasCustomViewsAccess,
      onClick: event => handleDeleteViewClick(event, id),
      testId: 'delete-view-button',
      disabledText: 'svh-workspace-ui-lib.custom-views.deleteDisabledTooltip',
      buttonText: 'svh-workspace-ui-lib.custom-views.deleteCustomViewButton'
    }]
  }, id);
};
InboxNavViewLink.displayName = 'InboxNavViewLink';
export default InboxNavViewLink;